/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnforcementStateEnum = "ApproachingLimit" | "NoEnforcement" | "ReachedLimit" | "%future added value";
export type ProductTypeEnum = "Business_NonStandard" | "Business_Standard" | "Enterprise_NonStandard" | "Enterprise_Standard" | "Pro_NonStandard" | "Pro_Standard" | "%future added value";
export type SubscriptionTypeEnum = "Expired" | "FreemiumOrg" | "LegacyPrePaywall" | "PaidBillingGroup" | "PaidOrgPro" | "PaidTeamPro" | "PaidUserPro" | "SelfServePremiumOrgQ42020" | "SelfServePremiumTeamQ12021" | "%future added value";
export type OrgPricingGrid_org = {
    readonly id: string;
    readonly experiments: ReadonlyArray<string | null> | null;
    readonly orgAccountingPeriod: {
        readonly __typename: "OrgAccountingPeriod";
        readonly periodRange: {
            readonly minDate: string;
            readonly maxDate: string;
        };
        readonly quotaMax: number;
        readonly quotaUsed: number;
        readonly enforcementState: EnforcementStateEnum;
    } | {
        readonly __typename: "GraphEntityError";
        readonly message: string | null;
        readonly statusCode: number | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly billingGroups: {
        readonly list?: ReadonlyArray<{
            readonly id: string;
            readonly name: string;
            readonly subscription: {
                readonly __typename: "SubscriptionDetails";
                readonly subscription: {
                    readonly productType: ProductTypeEnum | null;
                };
            } | {
                readonly __typename: "GraphEntityError";
                readonly message: string | null;
                readonly statusCode: number | null;
            } | {
                /*This will never be '%other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            };
        }> | undefined;
        readonly message?: string | null | undefined;
        readonly statusCode?: number | null | undefined;
    };
    readonly featureGrid: {
        readonly __typename: "FeatureGrid";
        readonly stateMetadata: {
            readonly primaryBillingGroupMetadata: {
                readonly subscription: {
                    readonly id: string;
                    readonly type: SubscriptionTypeEnum | null;
                    readonly productType: ProductTypeEnum | null;
                };
            } | null;
        };
    } | {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly " $fragmentRefs": FragmentRefs<"TeamJoinCreateDialog_org">;
    readonly " $refType": "OrgPricingGrid_org";
};
export type OrgPricingGrid_org$data = OrgPricingGrid_org;
export type OrgPricingGrid_org$key = {
    readonly " $data"?: OrgPricingGrid_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"OrgPricingGrid_org">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v4 = {
        "kind": "InlineFragment",
        "selections": [
            (v2 /*: any*/),
            (v3 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "productType",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "OrgPricingGrid_org",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "experiments",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "orgAccountingPeriod",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DateRange",
                                "kind": "LinkedField",
                                "name": "periodRange",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "minDate",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "maxDate",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "quotaMax",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "quotaUsed",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "enforcementState",
                                "storageKey": null
                            }
                        ],
                        "type": "OrgAccountingPeriod",
                        "abstractKey": null
                    },
                    (v4 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "billingGroups",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "BillingGroup",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "name",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "subscription",
                                        "plural": false,
                                        "selections": [
                                            (v1 /*: any*/),
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "PaymentSubscription",
                                                        "kind": "LinkedField",
                                                        "name": "subscription",
                                                        "plural": false,
                                                        "selections": [
                                                            (v5 /*: any*/)
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "type": "SubscriptionDetails",
                                                "abstractKey": null
                                            },
                                            (v4 /*: any*/)
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "BillingGroupList",
                        "abstractKey": null
                    },
                    (v4 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "featureGrid",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "PaymentStateMetadata",
                                "kind": "LinkedField",
                                "name": "stateMetadata",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PrimaryBillingGroupMetadata",
                                        "kind": "LinkedField",
                                        "name": "primaryBillingGroupMetadata",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "PaymentSubscription",
                                                "kind": "LinkedField",
                                                "name": "subscription",
                                                "plural": false,
                                                "selections": [
                                                    (v0 /*: any*/),
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "type",
                                                        "storageKey": null
                                                    },
                                                    (v5 /*: any*/)
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "FeatureGrid",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v3 /*: any*/),
                            (v2 /*: any*/)
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamJoinCreateDialog_org"
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '151f89eee77269f23a468aaa869db64b';
export default node;
